// Shared region (city) slug → Latvian display name map + helpers used by the
// unified LocationField and the profile page. Keep in one place so the "novads"
// label is consistent everywhere a location is chosen.
export const REGION_NAMES = {
  riga: 'Rīga', jurmala: 'Jūrmala', liepaja: 'Liepāja', ventspils: 'Ventspils',
  daugavpils: 'Daugavpils', rezekne: 'Rēzekne', jelgava: 'Jelgava', jekabpils: 'Jēkabpils',
  valmiera: 'Valmiera', ogre: 'Ogre', tukums: 'Tukums', talsi: 'Talsi', saldus: 'Saldus',
  kuldiga: 'Kuldīga', dobele: 'Dobele', bauska: 'Bauska', aizkraukle: 'Aizkraukle',
  aluksne: 'Alūksne', balvi: 'Balvi', cesis: 'Cēsis', gulbene: 'Gulbene', kraslava: 'Krāslava',
  limbazi: 'Limbaži', ludza: 'Ludza', madona: 'Madona', preili: 'Preiļi', sigulda: 'Sigulda',
  smiltene: 'Smiltene', valka: 'Valka', marupe: 'Mārupe', olaine: 'Olaine', salaspils: 'Salaspils', adazi: 'Ādaži',
};

// Latvian name → ascii slug (lowercase, strip diacritics).
export const asciiSlug = (s) => (s || '').toString().toLowerCase()
  .normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z]/g, '');

// Best-effort: derive a region (city) slug from a saved location name when the
// user has a precise location but no region selected.
export const deriveRegionSlug = (name) => {
  const target = asciiSlug(name);
  if (!target) return '';
  for (const [slug, label] of Object.entries(REGION_NAMES)) {
    if (slug === target || asciiSlug(label) === target) return slug;
  }
  return '';
};

// Display label for a region (city) slug — empty string when unknown so the
// caller can fall back to a server-resolved name.
export const regionLabel = (slug) => REGION_NAMES[slug] || '';
